import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import Btn from '../../../../components/btns/Btn'

function HomeBlog({classes=""}) {
  return (
    <>
    <style>{`
        .article__list { width: calc(100% + 24px); margin-left: -12px; margin-bottom: -24px; float: left; }
        .article__item { padding: 0 12px; width: 30%; float: left; margin-bottom: 24px; }
        .article__box { display: block; position: relative; border-radius: 16px; overflow: hidden; }
        .article__thumb { position: relative; padding-bottom: 79%; }
        .article__thumb img { position: absolute; width: 100%; height: 100%; object-fit: cover; transition: all .5s ease; }
        .article__content { position: absolute; width: 100%; height: 100%; background: linear-gradient(2deg, black 0%, transparent 50%); color: var(--white); bottom: 0; left: 0; display: flex; flex-flow: column; justify-content: end; padding: 20px; padding-top: 40px; transition: all .3s ease-in; }
        .article__content h4 { font-size: 20px; font-weight: 600; line-height: 1.25; margin-bottom: 14px; }
        .article__content .know-more { color: var(--white); padding-right: 84px; }
        @media (min-width:767.98px) {
            .article__item:first-child { width: 70%; }
            .article__item:first-child .article__thumb { padding-bottom: 68%; }
            .article__item:first-child .article__content h4 { font-size: 27px; }
        }
        .article__content h4, .article__content .article__text { max-width: 500px; }
        .article__content .know-more:hover { color: var(--white); }
        .article__content .know-more i { transition: all .3s ease-in; }
        .article__box:hover .know-more i { margin-left: 15px; }
        .article__text { margin-bottom: 16px; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
        .article__date { position: absolute; border-radius: 4px; top: 20px; left: 20px; background-color: var(--primary); padding: 4px 14px; font-size: 14px; font-weight: 500; color: var(--white); display: inline-block; z-index: 99; }
        .article__read__times { font-weight: 600; display: flex; align-items: center; position: absolute; z-index: 99; line-height: 18px; right: 20px; bottom: 23px; position: absolute; border-radius: 20px; backdrop-filter: blur(10px); }
        .article__read__times:before { content: ''; background: url(../assets/images/eye.svg) no-repeat; width: 18px; height: 18px; display: inline-block; background-position: center; background-size: 16px; margin-right: 6px; filter: brightness(0) invert(1); }
        .article__read__times h6 { font-size: 12px; font-family: 'NunitoSans_10ptRegular'; margin-bottom: 0; color: #fff; }
        .article__box:hover .article__thumb img { transform: scale(1.1); }
        @media (max-width:991.98px) {
            .article__item { width: 50%; }
            .article__item:first-child { width: 100%; }
        }
        @media (max-width:767.98px) {
            .article__item { width: 100%; }
            .article__text { display: none; }
            .article__content { background: linear-gradient(2deg, black 20%, transparent 50%); }
        }
        `}
    </style>
    <div className={`section-padding about-container ${classes}`}>
        <Container>
            <Row  data-aos="fade-up">
                <Col md={6}>
                    <div className="heading">
                        <h6><span>News & Blogs</span></h6>
                        <h3>News & <span>Articles</span></h3>
                    </div>
                </Col>
                <Col md={6} className='d-none d-md-block'>
                    <div className="text-end mt-3">
                        <Btn route="#" type="default"  value={"View All Blogs"} />
                    </div>
                </Col>
            </Row>
            <Row className='align-items-center' data-aos="fade-up">
                <Col md={12}>                    
                    <ul className="article__list">
                        <li className="article__item">
                            <a href="#" className="article__box">
                                <div className="article__date">
                                    March 22, 2022
                                </div>
                                <div className="article__thumb">
                                    <img src="../assets/images/blog/1.jpg" alt="" />
                                </div>
                                <div className="article__content">
                                    <h4>Agile Practices Evolve: Introducing Agile 2.0</h4>
                                    <div className="article__text">
                                        Agile software development practices have been widely adopted, but as the industry evolves, new challenges and requirements arise. This article introduces Agile 2.0, an updated approach that builds upon the principles of Agile while addressing the complexities of modern software development projects.
                                    </div>
                                    <span className="know-more">
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    <div className="article__read__times">
                                        <h6> 12 Views </h6>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li className="article__item">
                            <a href="#" className="article__box">
                                <div className="article__date">
                                    March 22, 2022
                                </div>
                                <div className="article__thumb">
                                    <img src="../assets/images/blog/2.png" alt="" />
                                </div>
                                <div className="article__content">
                                    <h4>Machine Learning Empowers Software Development</h4>
                                    <span className="know-more">
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    <div className="article__read__times">
                                        <h6> 12 Views </h6>
                                    </div>
                                </div>
                            </a>
                        </li>
                        <li className="article__item">
                            <a href="#" className="article__box">
                                <div className="article__date">
                                    March 22, 2022
                                </div>
                                <div className="article__thumb">
                                    <img src="../assets/images/blog/3.jpg" alt="" />
                                </div>
                                <div className="article__content">
                                    <h4>New Framework Released to Streamline</h4>
                                    <span className="know-more">
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </span>
                                    <div className="article__read__times">
                                        <h6> 12 Views </h6>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </Col>
                <Col className='d-md-none'>
                    <div className="text-center mt-3 mt-md-4">
                          <Btn route="#" type="default"  value={"View All Blogs"} />
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
    </>
  )
}

export default HomeBlog